module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAABVElEQVQ4T63TsUsCYRjH8e9zdBZZU2VN0RaEY9AQNRY0hC5BGWiLQdAf0BK2tdcQLTqkg2NCSZBzQlv/QDm0RREqpeETXpxcdnc6dOPd837e5/c+9wr//IjtJdI61Agwmd2iIiLazz4pVeMxw/RMkOfUhjTaaywwdqFzrS9uUaaAkmESzW7Lux+6k9eJjxoFYEGECibLuZg8/YBpPWvBrgMoGyYrXqiF1SmhhO01hsFxNi4HFriZ0UOUo66OXFE3zIpqsJ+Ly6kFJgs6XH3hRpVFP9QLQyiOhlk/n5dmZyh7eR15q1PsRkW4kwFWAwEGu2NamwvF8RCRkzX57AzF7soLBcoIQeeZuWF/wPYLH/T3aXR1Zn/sRHZW90Q9MNcOe8b3wXxBO/5rjStgySoWrsdCRO0BuP34rpGdhcl7NasPRBSaswkuUyItvxvUE+znTjtrvgEjmZkP1KVk6AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/insurance-new/plan-down-blue.png
// module id = NIFw
// module chunks = 4